var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightbulb-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.33301 14.6668H9.66634M6.66634 6.66683H9.33301M7.99967 6.66683L7.99967 10.6668M9.99967 10.2177C11.5763 9.46877 12.6663 7.86176 12.6663 6.00016C12.6663 3.42283 10.577 1.3335 7.99967 1.3335C5.42235 1.3335 3.33301 3.42283 3.33301 6.00016C3.33301 7.86176 4.42304 9.46877 5.99967 10.2177V10.6668C5.99967 11.2881 5.99967 11.5987 6.10117 11.8437C6.23649 12.1704 6.49606 12.43 6.82276 12.5653C7.06779 12.6668 7.37842 12.6668 7.99967 12.6668C8.62093 12.6668 8.93156 12.6668 9.17659 12.5653C9.50329 12.43 9.76286 12.1704 9.89818 11.8437C9.99967 11.5987 9.99967 11.2881 9.99967 10.6668V10.2177Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.4c88024a0c95b360511709b9379fd190.svg";
export { ForwardRef as ReactComponent };